import script from "./SocialFundRequestDocumentsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialFundRequestDocumentsDialog.vue?vue&type=script&setup=true&lang=js"

import "./SocialFundRequestDocumentsDialog.vue?vue&type=style&index=0&id=1dc7ea3a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dc7ea3a"]])

export default __exports__